"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateCodes = void 0;
const stateCode_class_1 = __importDefault(require("./stateCode/stateCode.class"));
const stateCodes_class_1 = __importDefault(require("./stateCodes.class"));
const aus_json_1 = __importDefault(require("./aus.json"));
const can_json_1 = __importDefault(require("./can.json"));
const gbr_json_1 = __importDefault(require("./gbr.json"));
const nzl_json_1 = __importDefault(require("./nzl.json"));
const usa_json_1 = __importDefault(require("./usa.json"));
exports.stateCodes = new stateCodes_class_1.default();
exports.stateCodes.addStateCodes("USA", usa_json_1.default.map(stateCode_class_1.default.fromObj), "State");
exports.stateCodes.addStateCodes("CAN", can_json_1.default.map(stateCode_class_1.default.fromObj), "Province");
exports.stateCodes.addStateCodes("GBR", gbr_json_1.default.map(stateCode_class_1.default.fromObj));
exports.stateCodes.addStateCodes("AUS", aus_json_1.default.map(stateCode_class_1.default.fromObj));
exports.stateCodes.addStateCodes("NZL", nzl_json_1.default.map(stateCode_class_1.default.fromObj), "Region");
exports.stateCodes.addEuropeStates();
//# sourceMappingURL=index.js.map